import React, { useEffect, useState } from "react";
import { 
	getEmployeeDetails
} from "../../../../redux/employee/employeeState";
import { connect } from "react-redux";
import ProfileHeader from "components/card/ProfileHeader";


const EmployeeProfile = ({
    getDetails,
    recordData,
	recordId,
    ...props
}) => {
    const [employee, setEmployee] = useState(null);

    const initials =
        recordData?.user_detail?.full_name
        ?.split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase() || "?"
    ;

    useEffect(() => {
        if (recordData) {
            setEmployee(recordData);
        }
    }, [recordData]);

    useEffect(() => {
        if (!recordData && recordId) {
            getDetails(recordId);
        }
    }, [getDetails, recordId]);
 
    return (
        <div className="gradient blue rounded-2xl shadow-md flex items-start gap-4">
            <ProfileHeader
                initials={initials}
                fullName={recordData?.user_detail?.full_name}
                designation={recordData?.emp_title}
                clientName={recordData?.client_name}
                employmentStatus={recordData?.employment_status_name}
                empCode={recordData?.emp_code}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
  recordData: state.employee.employeeDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
    getDetails: (data) => dispatch(getEmployeeDetails(data)),
});


export default connect(mapStateToProps, mapDispatchToProps)(EmployeeProfile);